import { Component, OnInit } from '@angular/core';
import { AimsCommonTableHeader, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { JobCategoriesTable } from '../../hrCommon';

@Component({
  selector: 'job-categories-table',
  templateUrl: './job-categories-table.component.html',
  styleUrls: ['./job-categories-table.component.css'],
  providers: [MainGridService]
})

export class JobCategoriesTableComponent implements OnInit {

  tablePermissions: AimsCommonTablePermissions = {
    create: false, // Set below in constructor
    update: false, // Set below in constructor
    delete: false,
  };
  initialTableElement;

  jobCategoriesTable: Observable<any>;
  jobCategoriesHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'jobCategory', label: 'Job Category', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(50)]},
  ];

  newJobCategoriesTable() {
    return new JobCategoriesTable();
  }

  constructor(
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>
  ) {
    this.tablePermissions.create = permissions.canCreate(permissions.ComponentID.HumanResourcesConfig);
    this.tablePermissions.update = permissions.canUpdate(permissions.ComponentID.HumanResourcesConfig);
    this.jobCategoriesTable = this.mainGridService.getAll('Hr/GetJobCategoriesTable', 'Hr/SaveJobCategoriesTable');
  }

  ngOnInit(): void {
    this.initialTableElement = this.newJobCategoriesTable();
  }

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  ngOnDestroy() {
  }
}
